const type = 'SET_LIMIT_PROPOSAL_SUBMITTING';

const setLimitProposalSubmitting = (data) => ({
  data,
  type,
});

export { type };
export default setLimitProposalSubmitting;
